import React from 'react';
import { graphql } from 'gatsby';
import { Meta } from 'react-head';

import BookLandingPage from '../../03-organisms/BookLandingPage/BookLandingPage';
import SEO from '../../01-atoms/SEO/SEO';

const Page = ({
  data,
  location,
  pageContext: { contentMap, openGraphImageUrl },
}) => {
  const {
    post: {
      childMdx: {
        body,
        frontmatter: {
          description,
          embeddedImagesLocal,
          embeddedImagesRemote,
          meta_description_override,
          meta_title_override,
          title,
        },
        tableOfContents,
      },
    },
  } = data;

  return (
    <>
      <SEO
        description={meta_description_override || description}
        location={location}
        title={meta_title_override || title}
      />

      <Meta content="article" name="og:type" />

      {!!openGraphImageUrl && (
        <>
          <Meta content={openGraphImageUrl} name="twitter:image" />
          <Meta content={openGraphImageUrl} name="og:image" />
        </>
      )}

      <BookLandingPage
        contentMap={contentMap}
        embeddedImagesLocal={embeddedImagesLocal}
        embeddedImagesRemote={embeddedImagesRemote}
        tableOfContents={tableOfContents}
        title={title}
      >
        {body}
      </BookLandingPage>
    </>
  );
};

export const query = graphql`
  query($sourceInstanceName: String) {
    post: file(
      sourceInstanceName: { eq: $sourceInstanceName }
      relativePath: { eq: "markdown/index.md" }
    ) {
      childMdx {
        body
        fields {
          readingTime {
            text
          }
        }
        frontmatter {
          description
          embeddedImagesRemote {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
          embeddedImagesLocal {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
          meta_description_override
          meta_title_override
          title
        }
        tableOfContents
      }
    }
  }
`;

export default Page;
